import * as React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import CampaignsTable from './CampaignsTable.component';

export interface ICampaign {
  id: string;
  name: string;
  charities: Array<string>;
}

export interface CampaignsListProps {
  campaigns: { all: Array<ICampaign> };
  charities: { all: Array<any> };
  classes: any;
}

const styles = {
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '60px 0'
  },
  table:{
    padding: 20
  }
}

class CampaignsListComponent extends React.Component<CampaignsListProps> {
  render() {
    const { campaigns, classes } = this.props;
    return (
      <div>
        <div className={classes.flex}>
        <Typography variant="display1">CAMPAIGNS LIST</Typography>
          <Link to="campaigns/add">
            <Button
              variant="contained"
              color="primary"
            >
              <Typography variant="display2">ADD CAMPAIGN</Typography>
            </Button>
          </Link>
        </div>
        <Paper className={classes.table}>
          <CampaignsTable fullWidth/>
        </Paper>
      </div>
    );
  }

}

const CampaignsList = withStyles(styles)(CampaignsListComponent);

export { CampaignsList };
